<div class="notifications">
    <div (click)="isToggle = !isToggle" class="head">
        Notifications
        <i class="fa"
           [class.fa-caret-down]="isToggle"
           [class.fa-caret-up]="!isToggle"></i>
    </div>
    <div [collapse]="isToggle">
        <div class="notifications-list">
            <span>
                <input [checked]="getIsSet(notificationSetting.NotifyRespondent, process.notificationSettings)" (click)="toggleSetting(notificationSetting.NotifyRespondent, process.notificationSettings)" id="notifyRespondent" type="checkbox">
                <label for="notifyRespondent">Notify respondents about the process</label>
            </span>
        </div>
        <div class="notifications-list">
            <span>
                <input [checked]="getIsSet(notificationSetting.NotifyAppraisee, process.notificationSettings)" (click)="toggleSetting(notificationSetting.NotifyAppraisee, process.notificationSettings)" id="notifyAppraisee" type="checkbox">
                <label for="notifyAppraisee">Notify appraisee about the process</label>
            </span>
        </div>
        <div class="notifications-list">
            <span>
                <input [checked]="getIsSet(notificationSetting.NotifyPm, process.notificationSettings)" (click)="toggleSetting(notificationSetting.NotifyPm, process.notificationSettings)" id="notifyPm" type="checkbox">
                <label for="notifyPm">Notify PM about the process</label>
            </span>
        </div>
        <div class="notifications-list">
            <span>
                <input [checked]="getIsSet(notificationSetting.NotifyHr, process.notificationSettings)" (click)="toggleSetting(notificationSetting.NotifyHr, process.notificationSettings)" id="notifyHr" type="checkbox">
                <label for="notifyHr">Notify HR about the process</label>
            </span>
        </div>
        <div *ngFor="let action of process.firstDuration.scheduledActions" class="m-t-20 info-questionnaire">
            <div class="caption">
                <div class="m-b-5">
                    Reminder type:
                </div>
                <div class="for-ngx-select">
                    <ngx-select [allowClear]="true"
                                [items]="scheduledTypes"
                                optionValueField="id"
                                optionTextField="name"
                                [defaultValue]="action.type"
                                (select)="action.type = $event"
                                placeholder="Choose reminder type">
                    </ngx-select>
                </div>
            </div>
            <div class="caption">
                <div class="m-b-5">
                    Days:
                </div>
                <div class="for-input">
                    <input [(ngModel)]="action.offsetDays" type="number" min="0">
                </div>
            </div>
            <div class="position-relative">
                <i (click)="removeScheduledAction(action)" class="mdi mdi-close"></i>
            </div>
        </div>
        <div class="mt-2">
            <div class="d-flex align-items-center">
                <span (click)="addScheduledAction()" class="add-btn">
                </span>
            </div>
        </div>
    </div>
</div>



